<template>
  <div >
   <div class="input-group mb-3" dir="ltr">
  <input
      type="text"
      class="form-control text-center "
      v-model="userInput"
      placeholder="کد را وارد کنید"
      @input="validateCaptcha"
      maxlength="5"
      v-mask="'#####'"
    />
  <div class="input-group-append">
    <img
          :src="captchaImage"
          class="input-group-text"
          :width="width"
          :height="height"
          @click="generateCaptcha"
          title="برای تولید کد جدید روی تصویر کلیک کنید"
        />
  </div>
</div>
  </div>
</template>

<script>
export default {
  name: "CaptchaBox",
  props: {
    width: {
      type: Number,
      default: 130,
    },
    height: {
      type: Number,
      default: 37,
    },
  },
  data() {
    return {
    captchaId: "",
      captchaImage: "",
      captchaCode: "",
      userInput: "",
      result: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.generateCaptcha();
    });
  },
  methods: {
       async generateCaptcha() {
      const res = await fetch(this.$GetapiBase()+"captcha/generate");
      const data = await res.json();
      this.captchaId = data.captchaId;
      this.captchaImage = data.image;
      this.userInput = "";
      this.result = "";
      //this.$emit("valid", false);
      this.$emit("update", {
        valid: data.valid,
        captchaId: this.captchaId,
        userInput: this.userInput,
      });
    },
   async validateCaptcha() {
      if (this.userInput.length === 5) {
        const res = await fetch(this.$GetapiBase()+"captcha/validate", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            captchaId: this.captchaId,
            userInput: this.userInput,
          }),
        });
        const data = await res.json();
            this.$emit("update", {
            valid: data.valid,
            captchaId: this.captchaId,
            userInput: this.userInput,
          });

        if (data.valid) {
          this.result = "✅ کد صحیح است";
          //this.$emit("valid", true);
        } else {
          this.result = "❌ " + data.message;
          //this.$emit("valid", false);
          this.generateCaptcha();
        }
      }else {
          this.$emit("update", {
            valid: false,
            captchaId: this.captchaId,
            userInput: this.userInput,
          });
        }
    },
  },
};
</script>
<style scoped>
.input-group-text{
    padding: 0% !important;
    cursor: pointer;
}
</style>
